module.exports = __webpack_public_path__ + "img/w4.02901b6c.png";